import { render } from "./xtx-numbox.vue?vue&type=template&id=a501ce5c&scoped=true"
import script from "./xtx-numbox.vue?vue&type=script&lang=js"
export * from "./xtx-numbox.vue?vue&type=script&lang=js"

import "./xtx-numbox.vue?vue&type=style&index=0&id=a501ce5c&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a501ce5c"]])

export default __exports__